import React, { useEffect, useState } from "react";
import axios from "axios";
import sharedStyles from "../styles/shared.module.css";
import usersStyles from "../styles/AdminUsers.module.css";
import { ArrowUpCircle, ArrowDownCircle } from "lucide-react";

type AdminUser = {
    id: number;
    nome: string;
    email: string;
    role: "ADMIN" | "SUPER_ADMIN";
};

const AdminUsers = () => {
    const [admins, setAdmins] = useState<AdminUser[]>([]);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const BASE_URL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("token");

    const headers = {
        Authorization: `Bearer ${token}`,
    };

    const fetchAdmins = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/admins`, { headers });
            if (Array.isArray(response.data)) {
                setAdmins(response.data);
            } else {
                setAdmins([]);
            }
        } catch (err) {
            console.error("Error fetching admins:", err);
            setAdmins([]);
        }
    };

    const handleAddAdmin = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await axios.post(
                `${BASE_URL}/admins`,
                { nome: name, email },
                { headers }
            );
            setName("");
            setEmail("");
            fetchAdmins();
        } catch (err) {
            console.error("Error adding admin:", err);
        }
    };

    const handleDeleteAdmin = async (id: number) => {
        try {
            await axios.delete(`${BASE_URL}/admins/${id}`, { headers });
            fetchAdmins();
        } catch (err) {
            console.error("Error deleting admin:", err);
        }
    };

    const handleToggleRole = async (id: number) => {
        try {
            await axios.put(`${BASE_URL}/admins/${id}/toggle-role`, {}, { headers });
            fetchAdmins();
        } catch (err) {
            console.error("Error toggling admin role:", err);
        }
    };

    useEffect(() => {
        fetchAdmins();
    }, []);

    return (
        <div className={sharedStyles.container}>
            <h1>Gerenciar Administradores</h1>

            <form onSubmit={handleAddAdmin} className={sharedStyles.form}>
                <input
                    type="text"
                    placeholder="Nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                <input
                    type="email"
                    placeholder="E-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit" className={sharedStyles.addButton}>
                    ➕ Adicionar
                </button>
            </form>

            <div className={sharedStyles.list}>
                {admins.map((admin) => (
                    <div key={admin.id} className={`${sharedStyles.card} ${usersStyles.card}`}>
                        <div className={usersStyles.cardInfo}>
                            <strong>{admin.nome}</strong>
                            <span>{admin.email}</span>
                            <span style={{ fontWeight: "bold", marginLeft: "10px" }}>
                                ({admin.role === "SUPER_ADMIN" ? "Super Admin" : "Admin Comum"})
                            </span>
                        </div>
                        <div>
                            <button
                                onClick={() => handleToggleRole(admin.id)}
                                className={`${usersStyles.toggleRoleButton} ${admin.role === "SUPER_ADMIN" ? usersStyles.rebaixar : ""}`}
                                style={{ marginRight: "5px" }}
                            >
                                {admin.role === "SUPER_ADMIN" ? <ArrowDownCircle size={18} /> : <ArrowUpCircle size={18} />}
                                {admin.role === "SUPER_ADMIN" ? "Rebaixar" : "Promover"}
                            </button>
                            <button
                                onClick={() => handleDeleteAdmin(admin.id)}
                                className={usersStyles.deleteButton}
                            >
                                🗑️ Deletar
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminUsers;